import React, {FC, MouseEvent} from 'react'
import classnames from 'classnames'

interface Props {
  children?: React.ReactNode
  className?: string
  fontSize?: 'xs' | 'sm' | 'lg'
  borderRadius?: 'none' | 'xs' | 'sm' | 'lg' | 'full'
  borderWidth?: string
  borderColor?: string
  bgColor?: string
  textColor?: string
  type?: 'button' | 'submit'
  onClick?: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
  ) => void
  disabled?: boolean
  form?: string
  data_cy?: string
  ariaLabel?: string
}

export const Button: FC<Props> = ({
  children,
  className,
  onClick = undefined,
  disabled = false,
  borderRadius = 'none',
  bgColor = 'bg-blue-600',
  fontSize = 'sm',
  textColor = 'white',
  borderWidth = 'border',
  borderColor = 'white',
  type = 'button',
  data_cy = '',
  ariaLabel = 'button',
  ...rest
}) => {
  return (
    <button
      {...rest}
      aria-label={ariaLabel}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        `${className} leading-snug rounded-${borderRadius} ${
          disabled ? 'bg-gray-500' : bgColor
        } text-${fontSize} text-${textColor} ${borderWidth} border-${
          disabled ? 'gray-500' : borderColor
        }`,
        {
          'pointer-events-none': disabled,
        },
      )}
      data-cy={data_cy}
    >
      {children}
    </button>
  )
}
